import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useCallback, useMemo } from 'react';
import { isInboxHelpdesk } from 'conversations-internal-schema/inbox/operators/inboxGetters';
import { getInboxOptions } from 'conversations-thread-data/move-to-inbox/public/operators';
import { INBOX_USERS, UNASSIGNED } from 'conversations-internal-schema/routing-rules/constants/RoutingTypes';
import { buildRoutingRulesFromType } from 'routing-ui/routing-rules/utils/buildRoutingRulesFromType';
import { jsx as _jsx } from "react/jsx-runtime";
export const MoveToInboxSelectInbox = ({
  currentInboxId,
  inboxData,
  loading,
  selectedInboxId,
  setShouldDisableRoutingRules,
  setRoutingRuleDefinition,
  setInbox,
  threadCurrentlyInHelpdesk,
  totalConversationsCount
}) => {
  const haveMultipleConversationsOnTicket = Boolean(typeof totalConversationsCount === 'number' && totalConversationsCount > 1);
  const inboxOptions = useMemo(() => {
    const inboxesToInclude = !threadCurrentlyInHelpdesk ? inboxData : inboxData && inboxData.filter(inbox => !isInboxHelpdesk(inbox));
    return getInboxOptions(inboxesToInclude, currentInboxId);
  }, [currentInboxId, inboxData, threadCurrentlyInHelpdesk]);
  const handleInboxOnChange = useCallback(evt => {
    if (inboxData === null) return;
    const selectedInbox = evt.target.value;
    const newlySelectedInbox = inboxData.find(ibx => ibx.id === selectedInbox);
    if (newlySelectedInbox && isInboxHelpdesk(newlySelectedInbox) && haveMultipleConversationsOnTicket) {
      setShouldDisableRoutingRules(true);
      setRoutingRuleDefinition(buildRoutingRulesFromType(UNASSIGNED));
    } else {
      setShouldDisableRoutingRules(false);
      setRoutingRuleDefinition(buildRoutingRulesFromType(INBOX_USERS));
    }
    setInbox(newlySelectedInbox);
  }, [inboxData, haveMultipleConversationsOnTicket, setInbox, setRoutingRuleDefinition, setShouldDisableRoutingRules]);
  return /*#__PURE__*/_jsx(UISelect, {
    "data-test-id": "move-to-inbox-select-inbox",
    disabled: loading,
    options: inboxOptions,
    value: selectedInboxId,
    onChange: handleInboxOnChange,
    placeholder: loading ? /*#__PURE__*/_jsx(UILoadingSpinner, {}) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.moveToInboxPrompt.inputPlaceholder"
    })
  });
};
MoveToInboxSelectInbox.displayName = 'MoveToInboxSelectInbox';
export default MoveToInboxSelectInbox;